import { Drawer, Spin } from 'antd';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { CloseIcon } from '../../assets/icons';
import { verifyPin } from '../../services/AccountApi/profileApi';
import { addCounter, addUserData } from '../../store/reducer/accountSlice';
import { NOTIFICATION_MESSAGES, PIN_VERIFICATION_TYPES } from '../../utils/constant';
import { removeCookie } from '../../utils/cookies';
import { toastNotify } from '../../utils/toastNotify';
import OTPInput from '../OTPInput';
import { keepReferralPropertyForLoginModalType } from '../../utils/keepReferralPropertyForLoginModalType';
import { usePinRetryLockout } from '../../Hooks/usePinRetryLockout';

const PinDrawerWithoutButton = (props) => {
  const {
    onCancel,
    open,
    pin,
    setPin,
    loading,
    setLoading,
    handleForgotPin,
    onSuccess,
    isRoute = false,
    pinVerificationType = PIN_VERIFICATION_TYPES.MARKET_PLACE,
  } = props;

  const dispatch = useDispatch();
  const currentUserData = useSelector((state) => state.userData);

  const {
    countDown,
    seconds,
    setWrongPinCount,
    disabledPinInput,
    setDisabledPinInput,
    minutes,
    remainingSeconds,
    timerCounter,
    fiveMinTimeCounter,
  } = usePinRetryLockout();

  const handleVerifyPin = async (value) => {
    setPin(value);
    if (value.length === 4) {
      setLoading(true);
      let formData = {
        pin: value,
        pinVerificationType,
      };
      try {
        const response = await verifyPin(formData);
        const userResponse = response?.data?.user ?? {};
        if (!response.isError) {
          dispatch(
            addUserData({
              userData: {
                ...keepReferralPropertyForLoginModalType(userResponse, pinVerificationType, currentUserData),
              },
            })
          );
          dispatch(addCounter(response?.data?.counter));

          const isDwollaVerified = response?.data?.user?.isDwollaVerified ?? false;
          if (!isDwollaVerified && pinVerificationType === PIN_VERIFICATION_TYPES.MARKET_PLACE) {
            toastNotify('error', NOTIFICATION_MESSAGES.WARN_DWOLLA_PENDING);
            setPin('');
            onCancel();
            return;
          }

          const isTOSAccepted = response?.data?.user?.isTOSAccepted ?? false;
          onSuccess(isTOSAccepted);
          localStorage.removeItem('wrongOtpCount');
          setWrongPinCount(0);
        } else {
          if (response?.data?.data?.loginRetryAttempt === 1) {
            localStorage.setItem('wrongOtpCount', 0);
          }
          if (response?.data?.data?.loginRetryAttempt === 2) {
            localStorage.setItem('wrongOtpCount', 1);
          }
          if (response?.data?.data?.loginRetryAttempt === 3) {
            localStorage.setItem('wrongOtpCount', 2);
            setDisabledPinInput(true);
            timerCounter();
            localStorage.setItem('pinRetriesTimeCounter', new Date().getTime());
          }
          if (response?.data?.data?.loginRetryAttempt === 4) {
            fiveMinTimeCounter();
            setDisabledPinInput(true);
            localStorage.setItem('wrongOtpCount', 4);
            localStorage.setItem('pinRetriesTimeCounter', new Date().getTime());
          }
          if (response?.data?.data?.loginRetryAttempt === 5) {
            localStorage.clear();
            localStorage.removeItem('redirectIntendedPage');
            removeCookie();
            window.location.href = '/login';
          }
          setPin('');
          toastNotify('error', response?.message);
        }
      } catch (error) {
        if (error?.response?.data?.data?.loginRetryAttempt === 1) {
          localStorage.setItem('wrongOtpCount', 0);
        }
        if (error?.response?.data?.data?.loginRetryAttempt === 2) {
          localStorage.setItem('wrongOtpCount', 1);
        }
        if (error?.response?.data?.data?.loginRetryAttempt === 3) {
          localStorage.setItem('wrongOtpCount', 2);
          setDisabledPinInput(true);
          timerCounter();
          localStorage.setItem('pinRetriesTimeCounter', new Date().getTime());
        }
        if (error?.response?.data?.data?.loginRetryAttempt === 4) {
          localStorage.setItem('wrongOtpCount', 4);
          setDisabledPinInput(true);
          fiveMinTimeCounter();
          localStorage.setItem('pinRetriesTimeCounter', new Date().getTime());
        }
        if (error?.response?.data?.data?.loginRetryAttempt === 5) {
          localStorage.clear();
          localStorage.removeItem('redirectIntendedPage');
          removeCookie();
          window.location.href = '/login';
        }
        setPin('');
        const { response } = error;
        toastNotify('error', response?.data?.message);
      } finally {
        setLoading(false);
      }
    }
  };

  const remainingSecondMessage=remainingSeconds < 60 ? `${remainingSeconds} seconds` : `${remainingSeconds < 10 ? `0${remainingSeconds}` : remainingSeconds} seconds`
  return (
    <Drawer
      className='pin footer-shadow quickbuy--drawer'
      width='100%'
      title={<p className='subhead-2 mb-0 ml-40 text-center'>Enter your PIN</p>}
      open={open}
      onClose={onCancel}
      closeIcon={!isRoute && <CloseIcon />}
      closable={!isRoute}
    >
      <Spin spinning={loading}>
        <p className='text-taupe text-center mb-40 fz-16'>For your security, please enter your 4-digit PIN to continue.</p>
        <OTPInput
          length={4}
          otp={pin}
          onClearOtp={pin}
          onChangeOTP={handleVerifyPin}
          className='otp'
          autoFocus
          disabled={loading || disabledPinInput}
          inputClassName='otp__input mb-56'
        />
        {countDown > 0 && <div className='mb-10 fw-500 text-center'>You can retry after {countDown} seconds</div>}
        {seconds < 300 && seconds > 0 && (
          <div className='mb-10 fw-500 text-center'>
            You can retry after {minutes > 0 && `${minutes} minutes `}
            {remainingSecondMessage}
          </div>
        )}
        <div className='text-center mb-8'>
          <Link className='fw-600 text-terracotta underline' onClick={handleForgotPin}>
            I forgot my PIN
          </Link>
        </div>
      </Spin>
    </Drawer>
  );
};

export default PinDrawerWithoutButton;
